var map = {
	"./fino.png": 1676,
	"./fino2.png": 8212,
	"./fino3.png": 2109,
	"./normal.png": 75,
	"./normal2.png": 5073,
	"./normal3.png": 9979,
	"./normal4.png": 1975,
	"./sério.png": 2094,
	"./sério2.png": 990,
	"./sério3.png": 359,
	"./zoião.png": 4908,
	"./zoião2.png": 9700,
	"./zoião3.png": 2941,
	"./zoião4.png": 2962
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8363;